export const ZAPIER_REMOVE_ACCESS_TOKENS =
  'integrations/zapier/REMOVE_ACCESS_TOKENS'
export const ZAPIER_REMOVE_ACCESS_TOKENS_STARTED =
  'integrations/zapier/REMOVE_ACCESS_TOKENS_STARTED'
export const ZAPIER_REMOVE_ACCESS_TOKENS_SUCCESS =
  'integrations/zapier/REMOVE_ACCESS_TOKENS_SUCCESS'
export const ZAPIER_REMOVE_ACCESS_TOKENS_FAILED =
  'integrations/zapier/REMOVE_ACCESS_TOKENS_FAILED'
